import { validateForm } from '../../../utils/validator';
import { traerTeams, isTeamFieldTaken } from '../../../utils/equipos';

export const modelTeam = {
  name: '',
  shortName: '',
  cambios: -15,
};

export const validateTeam = async (team) => {
  const schema = {
    name: {
      type: 'string',
      empty: false,
      messages: { stringEmpty: 'Ingresa un nombre' },
    },
    shortName: {
      type: 'string',
      empty: false,
      max: 10,
      messages: {
        stringEmpty: 'Ingresa un nombre corto',
        stringMax: 'El nombre corto debe tener como máximo 10 caracteres',
      },
    },
  };

  const currentError = validateForm(team, schema);

  if (!String(team.name || '').trim()) {
    currentError.name = 'Ingresa un nombre';
  }
  if (!String(team.shortName || '').trim()) {
    currentError.shortName = 'Ingresa un nombre corto';
  }

  if (!currentError.name || !currentError.shortName) {
    const teams = await traerTeams();

    if (
      !currentError.name &&
      isTeamFieldTaken(teams, 'name', team.name, team.tid)
    ) {
      currentError.name = 'Ya existe un equipo con ese nombre';
    }
    if (
      !currentError.shortName &&
      isTeamFieldTaken(teams, 'shortName', team.shortName, team.tid)
    ) {
      currentError.shortName = 'Ya existe un equipo con ese nombre corto';
    }
  }

  return currentError;
};
